import { Swiper } from "swiper";
import { EffectCards, Navigation } from "swiper/modules";

class PhotoSlider {
    constructor($el) {
        this.$el = $el;
        this.$slider = this.$el.find('[data-photoslider="slider"]');
        this.init();
    }

    init = () => {
        if (this.$slider.length) {
            this.swiper = new Swiper(this.$slider[0], {
                modules: [EffectCards, Navigation],
                speed: 1000,
                loop: false,
                effect: 'cards',
                addSlidesBefore: 0,
                cardsEffect: {

                    perSlideOffset: 15,
                    slideShadows: false,

                },
                navigation: {
                    nextEl: '[data-photoslider="next"]',
                    prevEl: '[data-photoslider="prev"]',
                },
                breakpoints: {
                    990: {
                        cardsEffect: {

                            perSlideOffset: 25,

                        },
                    },

                }
            });

        }

    }

}

export default PhotoSlider;
